module.exports = __webpack_public_path__ + "media/Loops Bass.59dfa3da.wav";